import { Button, Stack } from '@qred/components-library';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AMLFields from '~/components/shared/AMLFields/AMLFields';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { ICardOfferApplicant } from '~/interfaces/cardOffer';
import { RootState } from '~/store';
import { trackCardOfferActions } from '~/store/actions/analyticsActions';
import { updateApplicant } from '~/store/slices/cardOffer.slice';
import { onChangeInputEvent, onFocusSelectEvent } from '~/types/types';

interface ApplicantProps {
  applicant: ICardOfferApplicant;
  onBlur: (name: onChangeInputEvent | onFocusSelectEvent | string) => void;
}

const Applicant = ({ applicant, onBlur }: ApplicantProps) => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();

  const {
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  const formMethods = useForm<ICardOfferApplicant>({
    defaultValues: applicant,
    mode: 'onTouched',
  });

  const {
    handleSubmit,
    formState: { isSubmitting, isSubmitSuccessful },
  } = formMethods;

  const saveApplicant: SubmitHandler<ICardOfferApplicant> = (formData) => {
    dispatch(updateApplicant(formData));

    dispatch(
      trackCardOfferActions({
        actionName: 'edit_applicant_save_button_pressed',
      })
    );
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(saveApplicant)}>
        <Stack>
          <AMLFields trackFieldChange={onBlur} />
          <Stack align="center">
            <Button
              variant="secondary"
              data-cy="save_signer_button"
              fullWidth={mobile}
              size="md"
              type="submit"
              disabled={isSubmitting || isSubmitSuccessful}
            >
              {translate('Save')}
            </Button>
          </Stack>
        </Stack>
      </form>
    </FormProvider>
  );
};

export default Applicant;
